// src/i18n.js
import Vue from 'vue';
import VueI18n from 'vue-i18n';

// 引入语言文件
import en from './en.json';
import cn from './cn.json';
import tw from './tw.json';
import ms from './ms.json';

// 使用 VueI18n 插件
Vue.use(VueI18n);
let locale = localStorage.getItem('local');
if (!locale) {
  locale = 'cn';
  localStorage.setItem('local', locale);
}

// 创建 i18n 实例
const i18n = new VueI18n({
  locale,
  messages: {
    en,
    cn,
    tw,
    ms
  },
});

export default i18n;
